import type { IStockRepository, BatchesByAssetOptions } from '@/features/stock/domain/repositories/IStockRepository.js';
import type { StockBatchEntity } from '@/features/stock/domain/entities/StockEntity.js';

interface Deps { stockRepository: IStockRepository; }

export function createListBatchesByAssetUseCase({ stockRepository }: Deps) {
  return async function listBatchesByAsset(options: BatchesByAssetOptions): Promise<StockBatchEntity[]> {
    return stockRepository.listBatchesByAsset(options);
  };
}
